import React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';

const Footer: React.FC = ({}) => {
    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'row',
                padding: '5px',
                width: '100vw',
                backgroundColor: 'white',
                boxShadow: '0px -2px 10px rgba(0, 0, 0, 0.1)',
                position: 'sticky',
                alignItems: 'center',
                justifyContent: 'space-between',
                bottom: 0,
                zIndex: 1000
            }}
        >
            <Button loading={false} disabled={false} sx={{ minWidth: '75vw' }} variant="contained">
                הנפק
            </Button>
            <Button loading={false} disabled={false} sx={{ minWidth: '20vw' }} variant="contained" color="success">
                הצג
            </Button>
        </Box>
    );
};

export default Footer;
